// App configuration
export var config = {
  api: {
    useLocalStore: process.env.VUE_APP_STORE.toLowerCase() === 'localstorage', // VUE_APP_STORE: localStorage | api
    url: process.env.VUE_APP_API_BASE_URL,
    defaultInstitutionId: process.env.VUE_APP_DEFAULT_INSTITUTIONID,
  },
  auth: {
    provider: process.env.VUE_APP_AUTH_PROVIDER, // VUE_APP_AUTH_PROVIDER: localStorage | api | auth0
    url: process.env.VUE_APP_API_BASE_URL,
    auth0Domain: process.env.VUE_APP_AUTH_AUTH0_DOMAIN,
    auth0ClientId: process.env.VUE_APP_AUTH_AUTH0_CLIENTID,
  },
};
